"use strict";

var _slicedToArray = require("/usr/src/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColors = exports._variants = void 0;

var utils_1 = require("./utils");

exports._variants = {
  50: utils_1.withTint(0.95),
  100: utils_1.withTint(0.9),
  200: utils_1.withTint(0.75),
  300: utils_1.withTint(0.6),
  400: utils_1.withTint(0.3),
  500: function _(c) {
    return c;
  },
  600: utils_1.withShade(0.9),
  700: utils_1.withShade(0.6),
  800: utils_1.withShade(0.45),
  900: utils_1.withShade(0.3)
};

function getColors(color) {
  var variants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : exports._variants;
  var colors = {};
  var components = utils_1.parseColor(color);

  for (var _i = 0, _Object$entries = Object.entries(variants); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        name = _Object$entries$_i[0],
        fn = _Object$entries$_i[1];

    colors[name] = utils_1.hexValue(fn(components));
  }

  return colors;
}

exports.getColors = getColors;